module.exports = __webpack_public_path__ + "img/Dashboard.b76d8107.png";